// Copyright (c) 2019 Deere & Company

import '../../../styles/table.scss';
import { AgGridReact } from 'ag-grid-react';
import { ComponentCodeColumnDefinitions } from '../ag-grid-definations/component-function-code';
import PropTypes from 'prop-types';
import React from 'react';


const rowSelection = 'single';

function onGridReady ( params ) {

    params.api.sizeColumnsToFit();

}

function handleRowSelect ( props, params ) {

    const selectedRows = params.api.getSelectedRows();
    let selectedRowsString = '';
    selectedRows.forEach( ( selectedRow, index ) => {

        if ( index !== 0 ) {

            selectedRowsString += ', ';

        }
        selectedRowsString = selectedRow;

    } );

    props.onComponentFactorySelect( selectedRowsString );

}

function onComponentRowClick ( props, params ) {

    if ( params && params.data ) {

        props.onComponentFactorySelect( params.data );

    }

}

const ComponentCodeSearchPanel = props => (

    <div className="search-result-table-row">
        {props.productList.length > 0 && (
            <div
                className="ag-theme-balham ag-theme-popup"
            >
                <AgGridReact
                    columnDefs={ComponentCodeColumnDefinitions}
                    rowData={props.productList}
                    onGridReady={onGridReady}
                    rowSelection={rowSelection}
                    onSelectionChanged={handleRowSelect.bind( this, props )}
                    onRowClicked={onComponentRowClick.bind( this, props )}
                    popupParent={document.body}
                />
            </div>
        )}
        {props.productList.length === 0 && 'No Result Found'}
    </div>

);

ComponentCodeSearchPanel.displayName = 'ComponentCodeSearchPanel';
ComponentCodeSearchPanel.propTypes = {
    productList: PropTypes.array.isRequired,
    selectedComponentFunctionCode: PropTypes.object.isRequired,
};

export default ComponentCodeSearchPanel;
